import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const cirtRoutes: Routes = [
];

@NgModule({
  imports: [RouterModule.forChild(cirtRoutes)],
  exports: [RouterModule]
})
export class CirtRoutingModule { }
